<template>
  <div
    v-if="context.isCustomColumns || context.isFiltering || context.needsRefresh"
    class="flex gap-x-3 items-center"
  >
    <ResetBtn
      v-if="context.needsRefresh && showRefresh"
      @click="context.refresh"
    >
      Refresh
    </ResetBtn>
    <ResetBtn
      v-if="context.isCustomColumns && showColumnReset"
      @click="context.resetColumns"
    >
      Reset Columns
    </ResetBtn>
    <ResetBtn
      v-if="context.isFiltering && showFilterReset"
      @click="context.resetFilters"
    >
      Reset Filters
    </ResetBtn>
  </div>
</template>

<script setup>
import ResetBtn from '@/Components/DataGrid/Controls/ResetBtn.vue'
import { useGridState } from '@/Components/DataGrid/Composables/grid-state'

const { context } = useGridState()

const props = defineProps({
  showRefresh: {
    type: Boolean,
    default: true
  },
  showColumnReset: {
    type: Boolean,
    default: true
  },
  showFilterReset: {
    type: Boolean,
    default: true
  }
})
</script>
